export const lang = 'en-us';
export const title = 'Luis Naranjo';
export const description = 'Personal website';
export const image = 'https://placekitten.com/500';
export const url = 'https://luisnaranjo.me';
